import React from 'react';

class CreateAppointment extends React.Component {
  state={
    hour:"12:00",
    date:"",
    time:""
  }

  componentWillMount(){
    let date = new Date();
    date.setDate(date.getDate() + ((this.props.number - 1)*7));
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
    let textDate = date.getFullYear() + "-" + month + "-" + day;
    console.log(textDate)
    this.setState({date: textDate, time:textDate + " " + this.state.hour},() => this.props.onChange(this.state.time));
  }

  render(){

    return(
      <div class="bdrs-2 bdB w-100p mX-20 peers ai-c">
        <div class="ta-c  pR-10">
            <h2 class="m-0 c-client-secondary">
                <b>{this.props.number}</b>
            </h2>
        </div>
        <div class="consultation-info p-10">
            <div class="form-group p-0 mB-0 col-sm-12 date-time-input">
                <label> Data e hora da consulta</label>
            </div>
            <div class="p-0 w-100p">
                <div class="form-group pR-10 pL-0 mB-10 col-sm-7 date-time-input">

                    <input value={this.state.date} onChange={(e) => this.setState({date: e.target.value,time: e.target.value + " " + this.state.hour},() => this.props.onChange(this.state.time))} class="form-control" name="inputDate" type="date"/>
                </div>
                <div class="form-group  m-0 pR-10 pL-0 col-sm-5 date-time-input">
                    <input value={this.state.hour} onChange={(e) => this.setState({hour:e.target.value,time: this.state.date + " " + e.target.value},() => this.props.onChange(this.state.time))} class="form-control" name="inputTime" required="" type="time"/>
                </div>
            </div>
            <div class="peers ai-c jc-sb w-100p">
                <div class="peers ai-c">
                    <i class="fa fa-calendar-check-o mR-10 c-client-default fsz-lg"></i>
                    <div>
                        <span class="c-client-secondary fsz-xs">Data</span>
                        <h4 class="m-0 fsz-xs">{this.state.date}
                            <i class="fa fa-clock-o mL-5 c-client-default"></i>{this.state.hour}</h4>
                    </div>

                </div>
            </div>
        </div>
    </div>
    )
  }
}

export default CreateAppointment;



// WEBPACK FOOTER //
// ./src/panels/CreateAppointment.js